import { Loading, ErrorMessage, SimpleButton } from '@/src/ui';

export function renderLoaders(
    loading: boolean,
    success: boolean,
    error: string | null,
    isEdit: boolean
) {
    return (
        <>
            <Loading
                visible={loading}
                message={isEdit ? 'Updating question...' : 'Creating question...'}
                size="md"
            />
            <ErrorMessage error={error} />
            {success && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="question-success-msg"
                    className="fixed inset-0 flex items-center justify-center z-110 bg-[#00000040]"
                >
                    <div className="bg-white rounded shadow-lg p-6 flex flex-col items-center">
                        <div
                            id="question-success-msg"
                            className="text-green-700 font-bold text-lg mb-2"
                        >
                            {isEdit ? 'Question updated!' : 'Question created!'}
                        </div>
                        <SimpleButton
                            autoFocus
                            type="button"
                            className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
                            onClick={() => (window.location.href = '/questions/viewQuestions')}
                        >
                            OK
                        </SimpleButton>
                    </div>
                </div>
            )}
        </>
    );
}
